import React from 'react';
import GatewaysHeader from '../features/Gateways/components/GatewaysHeader';
import GatewaysBody from '../features/Gateways/components/GatewaysBody';
import CreateGatewayModal from '../features/Gateways/components/CreateGatewayModal';
import { useGatewayStore } from '../features/Gateways/store/gatewayStore';

const GatewaysContent: React.FC = () => {
    const { gateways, loading, error, fetchGateways } = useGatewayStore();
    const [openModal, setOpenModal] = React.useState(false);
    
    React.useEffect(() => {
        fetchGateways();
    }, []);
    
    return (
        <div className="w-full flex flex-col items-start justify-start p-4">
            <GatewaysHeader openModal={openModal} setOpenModal={setOpenModal} />
            <GatewaysBody gateways={gateways}/>
            {openModal && (
                <CreateGatewayModal openModal={openModal} setOpenModal={setOpenModal} onCreated={() => fetchGateways()}/>
            )}
        </div>
    );
};

export default GatewaysContent;
